import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { onAuthStateChanged } from 'firebase/auth';
import { BASE_URL } from '../url';
import { database } from '../config';
import SiteLayout, { PageHero } from './SiteLayout';
import LoadingSpinner from './LoadingSpinner';

function EditNews() {
  const { id } = useParams();
  const [imageURL, setImageURL] = useState('');
  const [postHeading, setPostHeading] = useState('');
  const [postDetails, setPostDetails] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [loggedIn, setLoggedIn] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const checkLoggedIn = onAuthStateChanged(database, (authUser) => {
      setLoggedIn(authUser || null);
      setAuthChecked(true);
    });
    return () => checkLoggedIn();
  }, []);

  useEffect(() => {
    fetch(`${BASE_URL}/news/${id}`)
      .then((response) => response.json())
      .then((newsData) => {
        setImageURL(newsData.imageURL || '');
        setPostHeading(newsData.postHeading || '');
        setPostDetails(newsData.postDetails || '');
      });
  }, [id]);

  function createNewPost(ev) {
    ev.preventDefault();
    axios.put(`${BASE_URL}/post`, { id, imageURL, postHeading, postDetails }).then((response) => {
      if (response.status === 200) {
        setRedirect(true);
      }
    });
  }

  if (redirect) {
    alert('News Updated Successfully!');
    window.location.href = '/getAllNews';
  }

  return (
    <SiteLayout>
      <main>
        <PageHero eyebrow="Admin" title="Edit news post">
          Update a published Raising Smiles story.
        </PageHero>
        <section className="section-padding admin-section">
          <div className="container">
            {!authChecked && <LoadingSpinner compact />}
            {authChecked && !loggedIn && (
              <div className="empty-state">
                <h2>Login required</h2>
                <p>You are unauthorized to view this page. Please login to continue.</p>
                <Link to="/login" className="btn btn-primary-rs">Login</Link>
              </div>
            )}
            {authChecked && loggedIn && (
              <form onSubmit={createNewPost} className="custom-form modern-form admin-form">
                <h2>Edit post</h2>
                <label htmlFor="edit-image">Image URL</label>
                <input type="url" value={imageURL} onChange={(ev) => setImageURL(ev.target.value)} id="edit-image" className="form-control" placeholder="Google Drive image URL" required />
                <label htmlFor="edit-heading">Post heading</label>
                <input type="text" value={postHeading} onChange={(ev) => setPostHeading(ev.target.value)} id="edit-heading" className="form-control" placeholder="Post heading" required />
                <label htmlFor="edit-details">Post details</label>
                <textarea value={postDetails} onChange={(ev) => setPostDetails(ev.target.value)} rows="7" className="form-control" id="edit-details" placeholder="Post details" required></textarea>
                <button type="submit" className="form-control">Update Post</button>
              </form>
            )}
          </div>
        </section>
      </main>
    </SiteLayout>
  );
}

export default EditNews;
